<template>
  <div
    id="protocols-view"
    class="pa-4"
  >
    <view-page-header :show-team-select="false" />

    <section class="protocols-view__protocols mb-6">
      <v-card class="rounded-lg">
        <v-card-title>
          <div class="subtitle-2">
            {{ $t('table_title.club_membership.plans') }}
          </div>
          <v-spacer />
        </v-card-title>
        <v-card-text class="pa-0">
          <v-data-table
            :headers="tableHeaders"
            :items="membershipPlans.data"
            hide-default-footer
          >
            <!--<editor-fold desc="ITEM SLOT">-->
            <template v-slot:item="{ item }">
              <tr>
                <td>
                  {{ item.title }}
                </td>
                <td>
                  {{ item.currency }} {{ Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(item.price) }}
                </td>
                <td style="width: 0;">
                  <v-btn
                    icon
                    @click="onEditMembershipPlan(item)"
                  >
                    <v-icon small>
                      fal fa-edit
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template
              v-if="membershipPlans.loading"
              v-slot:body
            >
              <tbody>
                <tr
                  v-for="i in 10"
                  :key="i"
                >
                  <td>
                    <v-skeleton-loader
                      type="text"
                      max-width="100px"
                    />
                  </td>
                  <td>
                    <v-skeleton-loader
                      type="text"
                      max-width="200px"
                    />
                  </td>
                  <td>
                    <v-skeleton-loader
                      type="text"
                      max-width="100px"
                    />
                  </td>
                  <td />
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </section>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import ViewPageHeader from '@/components/ViewPageHeader'
import { reactive } from '@vue/composition-api'
import { EventBus } from '@/plugins/bus'
import { MembershipPlanApiService } from '@/data/services/MembershipPlanApiService'
import i18n from '@/plugins/i18n'

export default {
  name: 'AdminMembershipPlansView',
  components: {
    ViewPageHeader
  },
  setup(props) {
    const tableHeaders = [
      { value: 'title', text: i18n.t('table_headers.admin_membership.title'), sortable: false },
      { value: 'price', text: i18n.t('table_headers.admin_membership.price'), sortable: false },
      { text: '', sortable: false }
    ]

    const membershipPlans = reactive({
      data: [],
      loading: true
    })

    const fetchMembershipPlans = debounce(async function () {
      try {
        membershipPlans.loading = true

        const resp = await MembershipPlanApiService.getAll()

        membershipPlans.data = resp.data
      } catch (e) {
        membershipPlans.data = []
      } finally {
        membershipPlans.loading = false
      }
    }, 500)

    return {
      membershipPlans,
      fetchMembershipPlans,
      tableHeaders
    }
  },
  computed: {
    currentTeamId() {
      return this.$store.state.teams?.currentTeam?.id
    }
  },
  created() {
    this.fetchMembershipPlans()

    EventBus.$on(this.$events.MEMBERSHIP_PLAN_CREATED, () => this.fetchMembershipPlans())
    EventBus.$on(this.$events.MEMBERSHIP_PLAN_UPDATED, () => this.fetchMembershipPlans())
    EventBus.$on(this.$events.MEMBERSHIP_PLAN_DELETED, () => this.fetchMembershipPlans())
  },
  methods: {
    onEditMembershipPlan(membershipPlan) {
      EventBus.$emit(this.$events.EDIT_MEMBERSHIP_PLAN, membershipPlan)
    }
  }
}
</script>
